import React from 'react';
import i18n from 'i18next';

export const ReferenceContext = React.createContext();
ReferenceContext.displayName = i18n.t('context.reference.referenceContextProvider');

export const ReferenceProvider = ReferenceContext.Provider;
